import * as React from 'react';
import { Provider } from 'react-redux';
// TODO to this theme provider for fabric as we go
import { ThemeProvider, theme } from '@Themes/themeOverriderFabric';
import { contexts } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';
import store from '../store';
import { PermissionsProvider } from '@Context';

export function AppProviders({ children }) {
    return (
        <Provider store={store}>
            <PermissionsProvider>
                <contexts.ThemeContext theme={getBaseTheme()}>
                    <ThemeProvider value={theme}>{children}</ThemeProvider>
                </contexts.ThemeContext>
            </PermissionsProvider>
        </Provider>
    );
}
